(function () {
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  function getDrawer(trigger) {
    const navbar = trigger.closest('.popout--navbar');
    if (!navbar) return null;

    const drawer = navbar.querySelector('[data-mobile-sort-drawer]') || document.querySelector('[data-mobile-sort-drawer]');
    if (drawer && !drawer.dataset.mobileSortTriggerId) {
      const triggerId = `mobile-sort-toggle-${Date.now()}`;
      trigger.id = trigger.id || triggerId;
      drawer.dataset.mobileSortTriggerId = trigger.id;
      document.body.appendChild(drawer);
    }

    return drawer;
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mobile-sort-drawer-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mobile-sort-drawer-open');

    const trigger = drawer.dataset.mobileSortTriggerId
      ? document.getElementById(drawer.dataset.mobileSortTriggerId)
      : null;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-mobile-sort-toggle]');
    if (!trigger || !mobileQuery.matches) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    openDrawer(getDrawer(trigger), trigger);
  }, true);

  document.addEventListener('click', function (event) {
    const closeButton = event.target.closest('[data-mobile-sort-close]');
    if (closeButton) {
      closeDrawer(closeButton.closest('[data-mobile-sort-drawer]'));
      return;
    }

    const submitButton = event.target.closest('[data-mobile-sort-submit]');
    if (!submitButton) return;

    const drawer = submitButton.closest('[data-mobile-sort-drawer]');
    const selected = drawer?.querySelector('input[name="mobile-sort-by"]:checked');
    if (!selected) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', selected.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-mobile-sort-drawer].is-open').forEach(closeDrawer);
  });
})();
